import { LegalLayout } from "./LegalLayout";

export function TermsOfServicePage() {
  return (
    <LegalLayout title="スカウトメールAI 利用規約">
      <p className="text-white/50 text-sm">最終更新日: 2026年2月17日 / 施行日: 2026年2月17日</p>

      <p className="mt-6 text-on-surface-variant leading-relaxed">
        この利用規約（以下「本規約」といいます。）は、株式会社WakeApp（以下「当社」といいます。）が提供する「スカウトメールAI」（以下「本サービス」といいます。）の利用に関する条件を定めるものです。本サービスをご利用いただくにあたり、本規約に同意いただく必要があります。
      </p>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第1条（定義）</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          本規約において使用する用語の定義は、以下のとおりとします。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            <strong>「本サービス」</strong>{" "}
            とは、当社が「スカウトメールAI」の名称で提供するブラウザ拡張機能およびこれに関連する一切のサービスをいいます。
          </li>
          <li>
            <strong>「利用企業」</strong>{" "}
            とは、本規約に同意のうえ本サービスの利用を申し込み、当社との間で利用契約が成立した法人、個人事業主または個人をいいます。
          </li>
          <li>
            <strong>「利用ユーザー」</strong>{" "}
            とは、利用企業に所属し、利用企業の許諾のもとで本サービスを利用する個人をいいます。
          </li>
          <li>
            <strong>「アカウント」</strong>{" "}
            とは、本サービスを利用するために利用ユーザーに付与される認証情報およびこれに紐づく利用環境をいいます。
          </li>
          <li>
            <strong>「送信情報」</strong>{" "}
            とは、利用ユーザーがブラウザ拡張機能を通じて当社のサーバーに送信するウェブページの情報をいいます。
          </li>
          <li>
            <strong>「生成コンテンツ」</strong>{" "}
            とは、本サービスのAI機能を利用して生成されるメール文面その他のテキストをいいます。
          </li>
          <li>
            <strong>「ブラウザ拡張機能」</strong> とは、Google
            Chrome等のウェブブラウザ上で動作する本サービスの拡張プログラムをいいます。
          </li>
          <li>
            <strong>「AIサービス」</strong>{" "}
            とは、本サービスにおいてメール文面生成等に使用する人工知能技術およびこれを提供する第三者のサービスをいいます。
          </li>
          <li>
            <strong>「利用契約」</strong>{" "}
            とは、本規約に基づき当社と利用企業との間に成立する本サービスの利用に関する契約をいいます。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第2条（本規約の適用）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            本規約は、本サービスの利用に関する当社と利用企業との間の一切の関係に適用されます。
          </li>
          <li>
            当社が本サービスに関して別途定める個別規約、ガイドライン、ポリシー（プライバシーポリシーを含みますが、これに限りません。）は、本規約の一部を構成するものとします。
          </li>
          <li>
            本規約の規定と個別規約等の規定が矛盾する場合は、個別規約等の規定が優先して適用されるものとします。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第3条（サービスの内容）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            本サービスは、利用ユーザーがブラウザ拡張機能を通じてウェブブラウザ上で閲覧中のウェブページの情報を当社サーバーに送信し、AI技術を活用してメール文面の生成等を行うサービスです。
          </li>
          <li>
            本サービスの主な機能は以下のとおりです。
            <ul className="mt-1 ml-6 list-disc space-y-1">
              <li>
                ウェブページ情報の整理:
                利用ユーザーがブラウザ上で閲覧しているウェブページの情報を、利用ユーザーの操作に基づき構造化・整理する機能
              </li>
              <li>
                メール文面生成:
                送信情報、利用企業が登録した情報およびテンプレートに基づき、AIを活用してメール文面を生成する機能
              </li>
              <li>テンプレート管理: メール文面のテンプレートを作成・管理する機能</li>
              <li>情報管理: 利用企業が登録する情報の管理を行う機能</li>
              <li>マッチング分析: 送信情報と利用企業が登録した情報のマッチング分析を行う機能</li>
              <li>チーム管理: 利用企業内の複数チームによるデータ管理機能</li>
            </ul>
          </li>
          <li>
            送信情報の取得は、利用ユーザーの明示的な操作に基づいてブラウザ拡張機能が読み取るものであり、自動巡回、自動収集その他のスクレイピング行為を行うものではありません。
          </li>
          <li>
            生成コンテンツの利用は、利用ユーザーが自らの判断で行うものであり、本サービスが自動送信を行うものではありません。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第4条（利用条件）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            個人事業主または個人が本サービスを利用する場合、本規約において利用企業が負う義務および責任は、当該個人事業主または個人が自ら負うものとします。
          </li>
          <li>
            利用企業は、本サービスの利用にあたり、利用ユーザーに対して本規約の内容を周知し、遵守させる義務を負います。
          </li>
          <li>
            利用ユーザーによる本サービスの利用に関する一切の行為およびその結果について、利用企業がすべての責任を負うものとします。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第5条（アカウント登録・管理）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            本サービスの利用を希望する者は、当社所定の方法によりアカウント登録を行うものとします。
          </li>
          <li>
            当社は以下の場合、登録を拒否でき、その理由を開示する義務を負いません。
            <ul className="mt-1 ml-6 list-disc space-y-1">
              <li>登録申込者が本規約に違反するおそれがあると判断した場合</li>
              <li>提供された情報に虚偽、誤記または記載漏れがあった場合</li>
              <li>過去に本規約に違反したことがある場合</li>
              <li>その他当社が登録を適当でないと判断した場合</li>
            </ul>
          </li>
          <li>
            アカウント情報を適切に管理する責任を負い、第三者への貸与・譲渡等をしてはなりません。
          </li>
          <li>アカウント管理不十分等による損害は利用企業が負い、当社は一切の責任を負いません。</li>
          <li>登録情報に変更があった場合は、速やかに変更手続きを行うものとします。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第6条（利用企業の義務）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            利用企業は以下を遵守するものとします。
            <ul className="mt-1 ml-6 list-disc space-y-1">
              <li>適用されるすべての法令を遵守すること</li>
              <li>閲覧するウェブサイトの利用規約等を遵守すること</li>
              <li>送信情報の取得・利用は、ウェブサイトの利用規約で認められた範囲内で行うこと</li>
              <li>送信情報に個人情報が含まれる場合、法令に基づく適切な取り扱いを行うこと</li>
            </ul>
          </li>
          <li>
            ウェブサイトの利用規約の遵守は利用企業の自己責任であり、当社は一切の責任を負いません。
          </li>
          <li>本サービスの利用が各ウェブサイトの利用規約に適合することを当社は保証しません。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第7条（禁止事項）</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          利用企業および利用ユーザーは、以下の行為を行ってはなりません。
        </p>
        <ol className="mt-3 list-inside list-decimal space-y-1 text-on-surface-variant">
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為に関連する行為</li>
          <li>第三者の知的財産権、プライバシー等の権利を侵害する行為</li>
          <li>本サービスのリバースエンジニアリング等の行為</li>
          <li>当社のサーバーに過度の負荷をかける行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>不正アクセスまたは他のアカウントの使用</li>
          <li>送信情報・生成コンテンツの第三者への提供・販売等</li>
          <li>機械学習モデルの訓練データとしての使用</li>
          <li>差別的・スパム的メッセージの送信</li>
          <li>アカウントの第三者への譲渡・共有</li>
          <li>当社未承認の営利目的の利用</li>
          <li>反社会的勢力等への利益供与</li>
          <li>その他当社が不適当と判断する行為</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第8条（知的財産権）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>本サービスの知的財産権は当社または当社のライセンサーに帰属します。</li>
          <li>
            生成コンテンツは利用企業が自由に利用でき、当社は権利を主張しません。ただし、第三者との紛争は利用企業の責任で解決するものとします。
          </li>
          <li>利用企業コンテンツの知的財産権は利用企業に帰属します。</li>
          <li>
            当社はサービス提供・改善に必要な範囲で利用企業コンテンツを使用できますが、AI学習には使用しません。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第9条（料金・支払い）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>利用料金は当社が別途定めるプラン・料金表に基づきます。</li>
          <li>月額サブスクリプション料金を当社指定の決済手段で支払うものとします。</li>
          <li>毎月自動的に課金されます。</li>
          <li>追加パック等は都度支払いとなります。</li>
          <li>料金変更は30日前までに通知します。</li>
          <li>支払済みの利用料金は原則返金しません。</li>
          <li>支払遅延の場合、年14.6%の遅延損害金を請求できます。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第10条（データの取扱い）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            <strong>送信情報の処理:</strong> 本サービスの機能提供目的で当社が処理します。
          </li>
          <li>
            <strong>データの保存:</strong> クラウドサービス上に保存します。
          </li>
          <li>
            <strong>保存期間:</strong> 利用企業が削除するか利用契約終了まで保存されます。
          </li>
          <li>
            <strong>AIサービスへの送信:</strong> AI処理のためにAIサービス提供者に送信します。
          </li>
          <li>
            <strong>AI学習への不使用:</strong>{" "}
            自社AIモデルの学習に使用せず、AIサービス提供者にも使用しないよう措置を講じます。
          </li>
          <li>
            <strong>セキュリティ:</strong> 合理的な安全管理措置を講じます。
          </li>
          <li>
            <strong>プライバシーポリシー:</strong> 個人情報の詳細はプライバシーポリシーに従います。
          </li>
          <li>
            <strong>利用企業の責任:</strong>{" "}
            個人情報が含まれる場合、法令に基づく法的根拠を自ら確保する義務を負います。
          </li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第11条（免責事項・責任制限）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>
            <strong>AI生成物の品質:</strong> 生成コンテンツの品質は保証しません。
          </li>
          <li>
            <strong>閲覧先との関係:</strong> ウェブサイトの利用規約への適合を保証しません。
          </li>
          <li>
            <strong>可用性:</strong> 「現状のまま（as is）」で提供されます。
          </li>
          <li>
            <strong>システム障害等:</strong> 不可抗力等による損害について責任を負いません。
          </li>
          <li>
            <strong>損害賠償上限:</strong> 過去12か月の利用料金総額を上限とします。
          </li>
          <li>
            <strong>間接損害の免責:</strong> 間接損害等について責任を負いません。
          </li>
          <li>故意または重大な過失の場合はこの限りではありません。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第12条（サービスの変更・停止・終了）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>保守・不可抗力等の場合、事前通知なく一時停止できます。</li>
          <li>終了の場合は30日前までに通知します。</li>
          <li>変更・停止・終了による損害について責任を負いません。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第13条（利用制限・登録抹消）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>規約違反等の場合、事前通知なく利用制限・登録抹消を行えます。</li>
          <li>措置による損害について責任を負いません。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第14条（解約）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>当社所定の方法により解約できます。</li>
          <li>課金期間の末日まで利用可能です。</li>
          <li>データのバックアップは利用企業の責任です。</li>
          <li>解約日から30日以内にデータを削除します。</li>
          <li>一部の条項は契約終了後も存続します。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第15条（反社会的勢力の排除）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>反社会的勢力に該当しないことを表明・保証します。</li>
          <li>暴力的要求等を行わないことを保証します。</li>
          <li>違反時は直ちに契約を解除できます。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第16条（準拠法・管轄裁判所）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>日本法に準拠します。</li>
          <li>東京地方裁判所を第一審の専属的合意管轄裁判所とします。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第17条（分離可能性）</h2>
        <p className="mt-3 text-on-surface-variant leading-relaxed">
          一部の条項が無効でも、残りの規定は完全に効力を有します。
        </p>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第18条（規約の変更）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>合理的な場合、利用企業の個別同意なく変更できます。</li>
          <li>効力発生日の30日前までに通知します。</li>
          <li>上記に該当しない場合は同意を得ます。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">第19条（連絡・通知）</h2>
        <ol className="mt-3 list-inside list-decimal space-y-2 text-on-surface-variant">
          <li>当社からの通知はサービス上の表示やメール等で行います。</li>
          <li>利用企業からの連絡は問い合わせフォーム等で行います。</li>
        </ol>
      </section>

      <section className="mt-8">
        <h2 className="font-bold text-white text-xl">附則</h2>
        <p className="mt-3 text-on-surface-variant">本規約は2026年3月1日から施行します。</p>
      </section>

      <hr className="mt-12 border-white/10" />
      <p className="mt-4 font-semibold text-gray-900">株式会社WakeApp</p>
    </LegalLayout>
  );
}
